<script setup lang="ts">
import { useIsMobile } from '@/composables/useMediaQuery'
import type { FilterOption } from '@/types/filter.types'
import { ref, watch } from 'vue'

const isMobile = useIsMobile()

const props = defineProps<{
  initialCategory?: FilterOption
}>()

const emit = defineEmits<{
  (e: 'change', category: FilterOption): void
}>()

// 카테고리 탭 옵션
const categoryOptions: FilterOption[] = [
  { idx: 0, name: '구매한 강좌', data: 'purchased' },
  { idx: 1, name: '찜한 강좌', data: 'liked' },
]

const selectedCategory = ref<FilterOption>(props.initialCategory || categoryOptions[0])

// props가 변경되면 선택된 카테고리도 업데이트
watch(
  () => props.initialCategory,
  (newVal) => {
    if (newVal) {
      selectedCategory.value = newVal
    }
  },
  { immediate: true },
)

// 카테고리 변경 핸들러
const handleCategoryChange = (category: FilterOption) => {
  selectedCategory.value = category
  emit('change', category)
}
</script>

<template>
  <div class="my-class-filter">
    <!-- 카테고리 선택 버튼 -->
    <div class="category-tabs">
      <div
        v-for="category in categoryOptions"
        :key="category.data"
        class="category-tab title-md"
        :class="{ active: selectedCategory.data === category.data, 'title-sm': isMobile }"
        @click="handleCategoryChange(category)"
      >
        {{ category.name }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.my-class-filter {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.category-tabs {
  display: flex;
  gap: 20px;
}

.category-tab {
  padding: 0px;
  border: none;
  background-color: transparent;
  cursor: pointer;
  transition: all 0.2s ease;
}

.category-tab.active {
  color: var(--white);
}

.category-tab:not(.active) {
  color: var(--gray-600);
}

@media (max-width: 1365px) {
  .my-class-filter {
    padding: 16px 20px;
    margin-bottom: 0px;
  }

  .category-tabs {
    height: auto;
    gap: 12px;
    align-items: center;
  }

  .category-tab {
    height: auto;
    padding: 0px;
  }
}
</style>
